var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',{staticClass:"nav-wrapper green"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"brand-logo",attrs:{"to":"/"}},[_vm._v("Administrador de empleados")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }